<template>
  <!-- for validation a reference with the name "accordionStep<stepnumber><uniqueName>" on the accordion component is needed
       e.g. ref="accordionStep1mvu" -->
  <v-expansion-panels 
                      v-model="uiOpenPanel"
                      :multiple="true"
                      accordion
                      class="accordion mt-4"
                      @change="onAfterExpandCollapse" >
    <v-expansion-panel v-for="(item, i) in items"
                       :key="i"
                       @change="onBeforeExpandCollapse(i, item.key)">
      <v-expansion-panel-header :class="headerClassToggle(i)"
                                class="panel-header" >
        <div :ref="`panelHeader_${item.key}`"
             :style="{ top: `-${ showHeader ? 300 : 65 }px` }"
             class="scrolling-anchor">
        </div>
        <div class="ueber2 primary--text elli">
              {{ item.name ? `${item.label}: ${item.name}` : item.label }}
        </div>
      </v-expansion-panel-header>
        <v-row v-if="allowDelete && items.length > 1"
               no-gutters
               align="center"
               justify="end"
               class="delete-icon-container px-2 my-n4"
               @click.stop="">
          <v-icon @click.stop="removePanel( item.key, i)">delete</v-icon>
        </v-row>
      <!-- eager is necessary for validation -->
      <v-expansion-panel-content eager>
        <component :is="componentName"
                   :ref="`accordionitem${i}`"
                   v-bind="item.childProps ? item.childProps : childProps"
                   :state-path="item.statePath"
                   class="mt-4" />
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</template>

<script>
import ImmobilieData from '../gewerberechner/ImmobilieData';
import FirmaBasis from '../gewerberechner/FirmaBasis';
import GewerbePerson from '../gewerberechner/GewerbePerson';
import GewerbeVorversicherungen from '../gewerberechner/GewerbeVorversicherungen';
import AddressData from '../gewerberechner/AddressData';
import GewerbeImmobilien from '../gewerberechner/GewerbeImmobilien';
import ZusatzbausteinePrivat from '../gewerberechner/ZusatzbausteinePrivat';
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';

export default {
  name: "DmbAccordion",
  components: { AddressData, FirmaBasis, GewerbeImmobilien, GewerbePerson, GewerbeVorversicherungen, ImmobilieData, ZusatzbausteinePrivat },
  mixins: [ twowayBindingMixin, ValidationMixin ],
  props: {
    /**
     * object: { label: string, name: string, key: string, statePath: string }
     * */
    items: {
      type: Array,
      required: true
    },
    componentName: {
      type: String,
      required: true
    },
    childProps: {
      type: Object,
      required: false,
      default: () => {}
    },
    allowDelete: {
      type: Boolean,
      default: false
    },
     openPanel: {
      type: Number,
      default: 0
    },
    statePath: {
      type: String,
      default: ""
    }
  },
  data: function () {
    return {
      showMultiple: false,
      userPanel: null,
      logIt: false // turns on console.log for this component
    };
  },
  computed: {
    panelCount: function() {
      let len = (this.items) ? this.items.length : -1;
      if (this.logIt) console.log("computed number panels: " + len);
      return len;
    },
    ...mapTwoWay([
      'uiOpenPanel'
    ]),
    showHeader() {
      return this.$vuetify.breakpoint.width > 1100 && this.$vuetify.breakpoint.height > 800;
    }
  },
  watch: {
    panelCount: {
      immediate: true,
      handler: function(newval, oldval){
        if (!this.statePath.includes(`step${this.$store.state.s.gewerbe.activeStepNumber}`)) return;
        if ( newval === oldval + 1){
          if (this.logIt) console.log("Panel ADDED - count: " + newval);
          this.uiOpenPanel = [newval -1];
        } else if ( newval === oldval - 1){
          if (this.logIt) console.log("Panel DELETED - count: " + newval);
        } else {
          if (this.logIt) console.log("OPEN First Panel on INIT - count: " + newval);
          this.uiOpenPanel = [0];
        }
      }
    },
    openPanel:{
      immediate: false,
      function(newval, oldval){
        if (this.logIt) console.log( "watch props openPanel: " + oldval + " -> " + newval);
        this.uiOpenPanel = (newval < 0) ? [] : [newval];
      }
    }
  },
  methods: {
    headerClassToggle: function (index) {
      return (this.uiOpenPanel.includes(index)) ? "bg-dimmed" : "bg-white";
    },
    removePanel: function(key, index) {
      if( this.uiOpenPanel.includes(index) ) {
        // close just the deleted panel (no auto open)
        this.uiOpenPanel = this.uiOpenPanel.filter((i) => i !== index).map((i) => (i < index) ? i : i - 1 );
      }
      this.$emit('remove', key, index);
    },
    onAfterExpandCollapse: function () {
      if (this.logIt) console.log( "onAfterExpandCollapse enter: " + this.uiOpenPanel.join());
      if(this.userPanel !== null){
          this.uiOpenPanel = [this.userPanel];
          this.userPanel = null;
        }
      if (this.logIt) console.log( "onAfterExpandCollapse exit: " + this.uiOpenPanel.join());
    }
    ,
    onBeforeExpandCollapse: function (index, key) {
      this.scrollEffectsOff(true);
      if (this.logIt) console.log( "onBeforeExpandCollapse user toggled panel: " + index + " open panels: " + this.uiOpenPanel.join());
      if(!this.showMultiple && !this.uiOpenPanel.includes(index) ) {
        //showMultiple simulates the expansion-panel-props multiple=false (wich means only one open panel)
        this.userPanel = index; 
        this.uiOpenPanel = [index];
        this.scrollIntoView(index, key);
      } else {
        setTimeout(() => this.scrollEffectsOff(false), 1000);
      }
    },
    scrollIntoView(index, key) {
      const ref = this.$refs[`panelHeader_${key}`];
      if (ref && ref[0]) {
        const el = ref[0];
        setTimeout(() => {
          var isInViewport = function (elem) {
              var bounding = elem.getBoundingClientRect();
              return (
                  bounding.top >= 0 &&
                  bounding.left >= 0 &&
                  bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                  bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
              );
          };

          if (!isInViewport(el)) { 
            //console.log("lets scroll");
            el.scrollIntoView({ left: 0, block: 'start', behavior: 'smooth' });
          } else {
            //console.log("lets NOT scroll");
          }
          setTimeout(() => this.scrollEffectsOff(false), 1000);
        }, 100);
      }
    },
    scrollEffectsOff(value) {
      window.DMB_NO_SCROLL_EFFECTS = value;
    }
  }
};
</script>
<style>
.accordion.v-expansion-panels {
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: none;
}

.accordion .v-expansion-panel-header, .accordion .v-expansion-panel-content {
  transition-property: none !important;
  transform: none !important;
  animation: none !important;
}

.accordion .panel-header {
  position: relative;
}

.accordion .panel-header .scrolling-anchor {
  position: absolute;
}

/*absolute positioning is necessary because of a z-index Bug in Firefox 6.0*/
.accordion .delete-icon-container {
  cursor: initial;
  height: 56px;
  max-width: 56px;
  position:absolute;
  top: 16px;
  right: 43px;
}

.accordion .v-expansion-panel-header--active + .delete-icon-container{
  top: 20px;
}

.accordion .v-icon {
  height: 24px;
}

.accordion .elli {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
